import Vue from 'vue'
import Router from 'vue-router'

import home from '../pages/home.vue'
import devicp from '../pages/devicp.vue'
import devicg from '../pages/devicg.vue'
import devicm from '../pages/devicm.vue'
import edgeServer from '../pages/edgeServer.vue'
import gateWay from '../pages/gateWay.vue'
import inside from '../pages/inside.vue'



Vue.use(Router);

const routes = [
  
  {
    path:'/',
    name :'home',
    component:home
  },
  {
    path:'/devicp',
    name :'Devicp',
    component:devicp
  },
  {
    path:'/devicg',
    name :'Devicg',
    component:devicg
  },
  {
    path:'/devicm',
    name :'Devicm',
    component:devicm
  },
  {
    path:'/edgeServer',
    name :'EdgeServer',
    component:edgeServer
  },
  {
    path:'/gateWay',
    name :'GateWay',
    component:gateWay
  },
  {
    path:'/inside',
    name :'Inside',
    component:inside
  },

]

const router = new Router({
//mode: "history",
  routes
})

export default router